import { IReduxStore } from "Redux/Store/IReduxStore";
import {
    DELETE_SPOT_LIST_REQUEST,
} from 'Redux/Action';
import { ArrayContains } from 'ClientService';

export const willBeDeleteSpotList = (state: IReduxStore): boolean => ArrayContains(state.spotList.openRequests, [
    DELETE_SPOT_LIST_REQUEST
]);